<script setup lang="ts">
import { useBreakpoints } from "@vueuse/core";

export interface IBreakpointMap {
  [key: string]: number;
}

export interface BaseHeaderLinksProps {
  links: IHeaderLink[];
}

const props = defineProps<BaseHeaderLinksProps>();

const visibleLinks = ref<IHeaderLink[]>([]);
const invisibleLinks = ref<IHeaderLink[]>([]);

const createCustomBreakpoints = (links: IHeaderLink[]): IBreakpointMap => {
  const initialDisplaySize = 1024;
  const breakpoints: IBreakpointMap = {};
  let previousSize = initialDisplaySize;

  for (let i = 0; i < links.length; i++) {
    const titleLength = links[i].title.length > 16 ? 14 : links[i].title.length;
    const margin = 28;
    const itemSize = previousSize + (titleLength * 10) + margin;
    breakpoints[i + 1] = itemSize;
    previousSize = itemSize;
  }
  breakpoints[1] = initialDisplaySize;

  return breakpoints;
};

const customBreakpoints = createCustomBreakpoints(props.links);
const breakpoints = useBreakpoints(customBreakpoints);

const resizeLinks = () => {
  const breakpointsMap = Object
    .keys(customBreakpoints)
    .reduce((acc: { total: number; size: any }[], value: string, index: number, array: string[]) => {
      acc.push({ total: +value, size: breakpoints.between(index.toString(), value) });

      if (index === array.length - 1)
        acc.push({ total: array.length, size: breakpoints[(array.length - 1).toString()] });

      return acc;
    }, []);

  breakpointsMap.forEach((item) => {
    if (!props.links.length)
      return;

    if (!item.size) {
      visibleLinks.value = props.links;
      invisibleLinks.value = [];
    } else if (item.size.value) {
      if (props.links.length > item.total) {
        visibleLinks.value = props.links.slice(0, item.total);
        invisibleLinks.value = props.links.slice(item.total);
      } else {
        visibleLinks.value = props.links;
        invisibleLinks.value = [];
      }
    }
  });
};

watch(() => breakpoints, resizeLinks, { deep: true, immediate: true });
</script>

<template>
  <div class="flex items-center max-w-[100%]">
    <BaseHeaderVisibleLinks :links="visibleLinks" />
    <BaseHeaderInvisibleLinks :links="invisibleLinks" />
  </div>
</template>
